import { FC } from "react";
import { Autocomplete, TextField } from "@mui/material";
import intl from "components/i18n/ReactIntlWrapper";

type StateSelectProps = {
  handleStateChange: any;
  selectedState: any;
  states: any;
  inputState: any;
  inputCountry: any;
};

const StateSelect: FC<StateSelectProps> = ({
  handleStateChange,
  selectedState,
  states,
  inputState,
  inputCountry,
}) => {

  return (
    <Autocomplete
      id="addressState"
      options={states || []}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      value={
        states && selectedState && inputState !== ""
          ? states.find((state) => state.name === selectedState)
          : null
      }
      onChange={(event, newValue) => handleStateChange(newValue)}
      disabled={!inputCountry}
      loading={states == null}
      renderInput={(params) => (
        <TextField
          {...params}
          label={intl.get("addressForm.placeholder.stateProvince")}
          placeholder={intl.get("addressForm.placeholder.stateProvince")}
        />
      )}
    />
  );
};

export default StateSelect;
